// libs
import React, { memo } from "react";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

// defs
import { Analytics, ToPayItem } from "@payment-client/interfaces/Checkout";

// styles
import { Row, Cell, SubText } from "./styled";

// hooks
import { useEffectOnce } from "@swiggy-private/core-ui";

interface IProps {
    toPayItem: ToPayItem;
    captureImpression: (payload: Analytics) => void;
}

const TotalPayableItem = ({ toPayItem, captureImpression }: IProps) => {
    useEffectOnce(() => {
        captureImpression(toPayItem.analytics);
    });

    return (
        <Row>
            {toPayItem.items?.map((cell) => {
                const { details, subtextDetails } = cell.displayContent || {};
                const textContent = details?.[0]?.text?.content || "";
                const subtextContent = subtextDetails?.details?.[0]?.text?.content;

                return (
                    <Cell key={textContent}>
                        <Text variant="V2.body2.neutral.bold" color="text_High_Emphasis">
                            {textContent}
                        </Text>
                        {subtextContent && (
                            <SubText variant="V2.overline.neutral.regular" color="warning">
                                {subtextContent}
                            </SubText>
                        )}
                    </Cell>
                );
            })}
        </Row>
    );
};

export default memo(TotalPayableItem);
